export default __webpack_public_path__ + "static/media/UNITY_ico.779d26cc.svg";